const ALGOLIA_SEARCH_KEY = process.env.GATSBY_ALGOLIA_SEARCH_KEY;
const ALGOLIA_APP_ID = process.env.GATSBY_ALGOLIA_APP_ID;
const ALGOLIA_INDEX_PREFIX = process.env.GATSBY_ALGOLIA_PREFIX || '';

module.exports = {
  ALGOLIA_SEARCH_KEY,
  ALGOLIA_APP_ID,
  ALGOLIA_INDEX_PREFIX,
};
